<template>
  <DbButton
    v-if="!showField"
    :label="labelAdd"
    :icon="addIcon"
    v-on:click-action="addField"
  />
  <div v-if="showField">
    <slot />
  </div>
  <DbButton
    v-if="showField"
    :label="labelRemove"
    :icon="removeIcon"
    v-on:click-action="removeField"
  />
</template>

<script lang="ts" setup>
import { computed, ref } from 'vue'
import IconDbPlus from '~icons/db/plus'
import IconDbMinus from '~icons/db/minus'

const props = defineProps<{
  /**
   * Force the field to be visible
   * (for example because there is already a value)
   */
  forceOpen: boolean
  /** Text for the button "Add" */
  labelAdd: string
  /** Text for the button "Remove" */
  labelRemove: string
}>()

const emit = defineEmits<{
  /** User requested to remove field */
  (e: 'remove'): void
}>()

const addIcon = { icon: IconDbPlus, class: 'db-text-color-supporting' }
const removeIcon = { icon: IconDbMinus, class: 'db-text-color-red' }

const userAskedToShowField = ref(false)
const showField = computed(() => {
  if (props.forceOpen || userAskedToShowField.value) {
    return true
  }
  return false
})

const addField = () => {
  userAskedToShowField.value = true
}

const removeField = () => {
  emit('remove')
  userAskedToShowField.value = false
}
</script>
